import React, { PureComponent } from "react";

class Tooltip extends PureComponent {
	constructor(props) {
		super(props);
		this.state = { close: false, timestamp: null };
		this.delayedClose = this.delayedClose.bind(this);
		this.close = this.close.bind(this);
		this.timeout = null;
	}

	// shouldComponentUpdate({ nextTimestamp }) {
	// 	const currentTimestamp = this.state.timestamp

	// 	return nextTimestamp !==
	// }

	close() {
		clearTimeout(this.timeout);
		this.setState({ expired: this.props.timestamp });
	}

	delayedClose() {
		clearTimeout(this.timeout);
		this.timeout = setTimeout(this.close, 6000);
	}

	render() {
		const { expired } = this.state;
		const { msg, timestamp } = this.props;

		if (!msg || typeof msg !== "string" || !timestamp || timestamp == expired) return null;
		this.delayedClose();

		return (
			<div onClick={this.close} data-timestamp={timestamp} className="calendar-tooltip">
				{msg}
			</div>
		);
	}
}

export default Tooltip;
